module.exports = {
	nav: {
		home: '홈페이지',						// 首页
		about: '회사소개',					// 关于我们
		project: '프로젝트 실경',					// 项目实景
		contact: '연락처',				// 联系我们
		language: '언어',			// 语言选择
	},
	content: {
		// 2021/11/12 内容区 要首字母大写
		about: '회사소개',					// 关于我们
		contact: '연락처',				// 联系我们
	},
	contact: {
		xing: '성',		// 姓
		name: '이름',		// 名
		email: '이메일',		// 邮箱
		address: '주소',	// 住址
		zhushi: '의견',		// 意见
		submit: '제출',		// 提交
		bitian: '필수사항',		// 必填项
		
		inputXing: '请输入您的姓氏(han)',			// 请输入您的姓氏
		inputName: '请输入您的名字(han)',			// 请输入您的名字
		inputZqEmail: '유효한 이메일을 입력하세요',	// 请输入有效的邮箱号
		
	}
}